/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../../hooks/useAuthorizedEpApps';
import config from '../../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../../constants';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import styles from './RecordToReportAgratasPage.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
// import AgratasTimeLiness from '../../../components/RecordToReportComp/AgratasPages/AgratasTimeliness';
import AgratasBankReconcilation from '../../../components/RecordToReportComp/AgratasPages/AgratasBankReconciliation';
import AgratasTimeLiness from '../../../components/RecordToReportComp/AgratasPages/AgratasTimeliness';

const RecordToReportAgratasChildPage = ({
    isAuthenticated,
    authPolicies,
    currentUserId,
}) => {

    // debugger
    const history = useHistory()

    console.log(history)

    const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
    const { showLoading } = usePopupManager();

    useEffect(() => {
        if (
            authorizedApps.length &&
            !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
        ) {
            showLoading();
            window.location.replace(config.HOME_UI_BASE_URL);
        }
    }, [authorizedApps, currentUserId]);


    const ChildScreen = () => {
        // debugger
        let path = history.location.pathname?.split("/")

        if (path.includes("Bank-Reconcilation")) {
            return <AgratasBankReconcilation />
        }
        else if (path.includes("TimeLiness")) {
            return <AgratasTimeLiness />
        }

    }


    return (
        <div className={styles.container}>
            <ChildScreen />
        </div>
    )
}

RecordToReportAgratasChildPage.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    authPolicies: PropTypes.object.isRequired,
    currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
};

export default connect(({ auth, userProfile }) => ({
    isAuthenticated: auth.isAuthenticated,
    authPolicies: auth.authPolicies,
    currentUserId: userProfile.userId,
    setAuthToken: authActions.setAuthToken,
}))(RecordToReportAgratasChildPage);
